/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InputNumCalViewNftPurchase.vue?vue&type=template&id=51d02e72&scoped=true"
import script from "./InputNumCalViewNftPurchase.vue?vue&type=script&lang=js"
export * from "./InputNumCalViewNftPurchase.vue?vue&type=script&lang=js"
import style0 from "./InputNumCalViewNftPurchase.vue?vue&type=style&index=0&id=51d02e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d02e72",
  null
  
)

export default component.exports